webpackJsonp([169928946856436],{

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _aboutUsSplash = __webpack_require__(870);
	
	var _aboutUsSplash2 = _interopRequireDefault(_aboutUsSplash);
	
	var _Splash = __webpack_require__(23);
	
	var _Splash2 = _interopRequireDefault(_Splash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = {
	  backgroundImage: 'url(' + _aboutUsSplash2.default + ')'
	};
	
	var AboutUsSplash = function AboutUsSplash() {
	  return _react2.default.createElement(_Splash2.default, { style: style, title: 'About Us' });
	};
	
	exports.default = AboutUsSplash;
	module.exports = exports['default'];

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeadshotImg = function HeadshotImg(props) {
	  var imgPath = props.imgPath,
	      name = props.name,
	      jobTitle = props.jobTitle;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('img', { src: imgPath, style: { width: '175px', height: '175px', marginLeft: 'auto', marginRight: 'auto', marginBottom: '2rem', display: 'block', borderRadius: '50%', boxShadow: '0 16px 38px -12px rgba(0, 0, 0, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)' }, alt: name + ' profile' }),
	    _react2.default.createElement(
	      'h3',
	      { style: { textAlign: 'center' } },
	      _react2.default.createElement(
	        'p',
	        null,
	        name
	      )
	    ),
	    _react2.default.createElement(
	      'h4',
	      { style: { textAlign: 'center' } },
	      _react2.default.createElement(
	        'p',
	        null,
	        jobTitle
	      )
	    )
	  );
	};
	
	exports.default = HeadshotImg;
	module.exports = exports['default'];

/***/ }),

/***/ 870:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/about-us-splash.f5b5d76e.jpg";

/***/ }),

/***/ 871:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/berkeleyhaas.89f82499.jpg";

/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/des-circle-low.6e5b171c.jpg";

/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ebclc.2d856471.jpg";

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/impacthuboakland.6058a3b9.png";

/***/ }),

/***/ 883:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/kell-circle-low.99371677.jpg";

/***/ }),

/***/ 884:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/kevin-circle-low.acdb1671.jpg";

/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/lccr.ef9d0b96.jpg";

/***/ }),

/***/ 887:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/lylescenter.3a3afc28.jpg";

/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ocedfresno.60797520.jpg";

/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/selc.d31ab28e.png";

/***/ }),

/***/ 893:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAASABIAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQECAgICAgICAgICAgMDAwMDAwMDAwMBAQEBAQEBAQEBAQICAQICAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDA//CABEIACcBCgMBEQACEQEDEQH/xAAfAAABBAMBAAMAAAAAAAAAAAAJBAYICgMFBwIAAQv/2gAIAQEAAAAAv2V7esG9UwimgNIkW1HWQmAZAfcU8koVvOq+mxsZLcQeIPnSk19QRmcOwlg345EokKorGyCdhslddyZIybRStDXBOPIeIUDzMe14bfJdIaTuT1MWvaW7Jpqziez2trIjuupOfMkoRXwHR88QEhucaH1XYqx6stWO0cuxKk/579ik+S2LY2xJ3IdnWJPDVWuNuPHWCs7qvGpq42YejQ9r3FMK+5IFg9Lhwk3+Kq/Jh9HJyD8kf3FUwXUyNm+MPNOjK8cT++O5VpI0qZHbrDxyExIt/j5y/eN9h//EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAIAQIQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP//EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAIAQMQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP//EADcQAAEEAQIEAgcECwAAAAAAAAQBAgMFBgARBxASFBMVISMxNTZBdRciNFUWICUzRFNUVnSh0f/aAAgBAQABEgNV2TRfEWtQuUGorrbIZh3dMz6TPae3M8rmjNp7X5Ab8r6/BxwOM2wSdYpS4Q2Jvq6y2poyRQJ+5KsTV9RXNd1I1elzFc1F6ND5PWkXpeOqhI9mJF4/h76t8mrqYmuBnQgg61m8EMPfkZYzhtdItXYExt1V3dZcRySVxTZ/Bf4c8SLvyLJjCFJMm6vCFgmJk03injr2tewS9cxyIrXfahj6/wAFf6Rd/wDS87zOaGjn7KSWY2y/LncSIxtpbDF8oADX2l1VvXXYjDqsqMoZ+6dfIPIgDrizpIUI7ypZC8lXyxxtc+RyMYxrnvfSZXW5CQXDVxmzwBu6JLHWYuJbi964Tq7hK0ro1gDa5uJU3lnR4bhmvI1LWV5BYx84kExoiPQUnlxY+HAtvnf1qayfLHgzsoaCBLPJjU9UPi2IMpXz2VgQtnkZ27jrJEXlntCURALkdN92/wAed3I2q7K6s/GkyR0rYQ2DOkNTCQC7qwLzq4YrSD08CjGROW2s5AmrGJmlOiRWtSsampVHw2teFYj/ALk0aMhnLIPcN19JsdcPPg2h/wAR3pdpOWdX01Dj804fvAyWKvrtYjiYmOBtVzEntyUSayPfGj2qxfS1yKjkpscqaF58lYK0ZbGZJyU0uqSeAXPs9JJljgGhFrpJpnTWfEkhRxFIrMKgl9eUCAJWjQhAwRjCQM6IodSIjm9Ko1Ud91UJ4fzBEzm4heFY9JOvXKBWZVkNVdB4/mAg3VYu8OsuE5cV/hwP27efV2+gXP4b35LLdil09/Oqw5LG9r0a9jkex7Gua7kurXFWpm0GLwlyQY9kKpfmV8UbYWtjjaxkTGo2NnPKZIo8bvXzbeGlSei64cNkZhlEknt7eZ7eWQ+4bv6RZaxDGbo/G6kobMbWtglHVYwh8SvoSRppM4uCY4Z4ZZBk5cTvVsxUqT8INkwSk6T/ALy35Lq0xyfJcqzoIUmSEqFlaXDBhOUwWsDqkoRlRd1KduXUoqLyujp62rMOGCmsZxoXSMDo89x24EjnlsRK4vpb3IN3ZjZlkmN1NCqGw09ky2s7JOXFj4cC9nv+t1ZVoVuHOAfCwgUhu0jQLE7hxYRUV1K8nFS5P2PbRvbI1r2Oa9j2o9j+VoqfapjP0CwT9RzkRN1VET076yEqXN5f0ZonK+oaRG7IbsUeEUeEYdiRwjxRwxR6yH3Bd/SLHWE5jjFbi1MEbciDkwDvbLD9oGG/3ADqKaOeNksTkfHLGyWN+slo4MipjKqf7vcNRYZaHNFpEZQZsjqyyERIIrA3M8WDHdPLeVzm9O6MxPJLDJCLEvytQqFOhtUVyxv08Rs422/D12svxCWzWO7pJOxyav2UQnD8vivmShHs8uyED1VjWb6XR2K49ZzdwfTVxMy7q6QGsArIvArwxQ4fnHyIFHLYkZMEJDGvSRGdPy9GiBByo/CJggIiVUcscEEY7GxwsZFExqMZFycGO8hhawwqTE1Y4yOZdJWn/jBkKTfdY4h4R2Migiihhj9EcScpGNlY6N7WvY9Fa9iUVL+UVevI6b8prNNY1iI1qI1rURrW6XRdeFYR+CcIMXF/LhwvFR5PGioKtsntRWMRiIiIiIjUaicoxBop5SYx4GEToiTTuTdNeXh9z3naC93/AFPTr//EADwQAAIBAgMEBgYIBgMAAAAAAAECAwQRABIhECIxQQUTFDJRYSAjQmJxgSQzQ1KEkdPwFTSCksHhcqHS/9oACAEBABM/A/34Y6Jpeup0bXTr83rDcaZQQ3I46Wh7LLIeaxXYhn93RvLbTxiV+unDlLgugC2jPPH71x0fCKqsI132jzoqJpxJH/Rww3l0BytlLLmF/HZUxLHHUw7p6ykkEjCZcrg8tL+DWxRxCaoaxAaV1aSMRwqTxJ8fA7aIU9RJbxEHaUmf4KC3lgrJDU08lyuSopZ1jqIGzA95Rw2oMz9XBG0j5Rpdsq4XotmU38GWUqbY/hT/AKuPjt6Ni7XVAngJApCRHyJBxPQXiUeLjrd0fnhOKuLZo5Y2tJFKubUEc9rxhYCJwGXqnzksRfW4GHIRURBmZ2LWsqga4NPk6Pke4skE7SZpWIN9F7uvMXwl8/1ZzlbEG4jv/vhhAMzVp1q+vI+2We415cNLYeNXlgz2zdXIV3dvju1OnEYGsNBGR/NV7ZgEA4hDbxNhbNMcxQtlJgpRp1UA08L25LYDXYoJ7VSKS9RSMg+sGW7BfaGZfawxu1NPDpPTEd5362wX7+YW44bUUXRIvvJ703ANzGZvtPQTdTpPo1mSOaCqUD1rRLbK3EKPJbeGdQSh8420+Wz8HMMeP0mb/Axb/Rx8bbOYqqm+WQA6M0KAsAbgkWOmJN+aWoffdFd7lYo2Y2tlzcSL4beuDxBDA3DflhC2TMubIkaElYokzmwH3j5DbKckUSJFE2eR2ORcb0VV060cn1UKneWlzDnoP+QsIhZV8fMknUk3LE3OuxuBU97Q3B0xbtXRkrAnJ6lyerQW4WcKNAAMUO7TVUm7ZHjbLkZs1uCkNYZbG+0HLpkqfI/Lzw656+GbLmaPpCTUsma5b+/3QlmQqwBVlZeKMOG35Yj0TPRCoMsK/cEzwcu7m90YQZVRVsAqqN0KBwHL0D4tSyrGBfm0hFvPB49XJVzvH8ip/LZ+CmxBBA0VOBLIuVGYgkXF8S08AjnSOQO0LkPcK4Ftp7qqc9mPkqqcfP0c+WjrZFjibs1YODKcu4x7ra4SLs8YWIkCWjgOqxC2qcUv93KdsBtJNbjbmRGN4hbuQN0E2BrZ0ppYJRbOqGUoKiO+oZb+BsbgRD1FOsBjsiS+2xIN7cWy4/fhsPPdqeH74YYa+7IkgsY5UOqsNVw/eoMx/lakjgq315DvABbhU1R1YXDqw0ZWB02/09IH0DppYk8bcsJfsiwwusgoKGbuVUxZbtl0BW18LwSONFRFt5Kuz8HNhy+ZG6+U2NkPI4zSf+MDuvHIMyMPiNg+wqYzngm+Aca+6TiRHai6RhjCpHN2hQVD5eJ4G1zYm2IKmOqnfwC01O0k73+GJyUqqpk0mJi1V4iToQbJw3uWz+iMHxwhydtSMN9EqnN13gd1209lt3UTerkLJumopopPWNCT3hr1ZtfiC2mx6desdjbWSRcpkOntXxTwpCG826sLmPx12zxrKodb5XAcGzi/HHl8MTxpKhI0uVkVgSBiJVjjVRwyIgVUHlw2mMGdEa+ZVk4hSGOnoTyTSQNbk8DyNCw+K4ijWONB4IiBVXa4DI6kWKsrAgqcdgpf0sdgpf0sKLAKO6ABoAu2pgjmT+11P+MNSRyKp92OQMgwosAo7oFrCyjy2pDGs0wHd62VVDvbZ1Cdo4ZbddYvYLYfL8sf/8QAJhABAAICAQMEAgMBAAAAAAAAAREhADFBEFFhcYGR8KGxwdHx4f/aAAgBAQABPzK4v2uuX2Xk3omDYJB1HJSFvDSI9yVHpyULEDAHv/HpJUnR5nk7sZpDiNU34v4wloQcGVEyjbWkiE+KCKVUmhbCJ1PTWNbVfPWIcGSPn9eu41jepUKTEivEhNZaLxzkRs1ldMTk3CyTAhkTIz6i8uzg6zc8biv30NpnM4BOiRiUJ5w+m1lHgYhvBkCtAbloOGHcmIBRJNN9Fj74n3yRbBCyCq41y0YjBr5J0tQVHIrxkZxxUnYgiIZgOk6luEfm2Ej9zxCvAgKsJkuC9Yt/RGtUo26BKDFJ9/3EdK7KBWLCCPjZvUsiGyxYCLiAAhJGuRLQMKqrnA+/5B0lArCNSd6jIJa9OqqCKCrScURP/Db9MGJEhgibhriF80qQ8HGI8d/9/GBtZNwUaBWCh5jTuFJ30R9l5RxFIL0oIqf+CQxvf88vie2ffu8Z+Na7TeobM76jhxysqWGwM213JfvpR8T0Xh3CeqA2Wrlk2304IrtSD2zS9c7QQzsdZ3fnzI1x0JaSCmGS4h4OCThnpj1OY/jzJzABIhg18IqR0dZOw/DbbwWlOggzT3P3kvZfoBBGDm67YynM5b5TvOCGNS302rO02ZlysljFOkzIqCDZsIjGC3YwQoENID46rJA315RXpNgw0CvvcbHpzbB5JyyU3DUXjKK7khccCdVCScXaAZN1IMy+z6ZPH399Cv59GxfiXJO2/wA1kRpj3BryE6tflDmQHD2Oq2aSYayIlvIZOUKx23+A9HTuohaxc9f/AKjFmt3y9O9GdBCt1gifP9GOQpqVoT4Nz8Zv6y8fsXOLGAdefSq999LEf77ZwarzvPo0QcWoXHZmiqJIAEpySqIcb99Pke/tvoUsDyvUNUxGJ4tPEXyI2TI0aHM30j1kWGkCImpT41r1hL/Doo5aIKJa13j9s8ZdxF8DpcYkvGtYAssrAypkORGBr/5hhO5MoYTo4YeT3FD4MGfz+/8AnTWNxAUoYXKgBleAyCSMlE0I4ukKzkylsAqyiIR09JTPqGcNP7eUGh6Kbt7BgU+zY47VViukEscd4OcnnV8ZH1iQbFCCV1rJuotiD1JlvIKG1ZcNMXSvQsGbJLuE14pD3HCch4zImRRItOrCZyJiZDsEgCULHR+v9sE/ONEGbLtVtsEcMZUcyXo1CCFsPlgR9/jx0KXymYBgrgWC5pSGmj1EAIxFXTO2YSxrVZAN2yaCFfiQ45nEk/vIjfali9a3S8CO3zPt6dG/v9ZLTkS2U+jfTCKDwCpBQVgTfb1Z5vnosIosYcVbMA6uK47nttcYKv8ABJ2qWEj6odCGDaDoJI/mPyY5ZxIgmpIVjs4AiiwDETs/wCcOGK0pAQR1w4H5x49fvrkMXjzvCDqXKb784FKsTjojlisCYOGjEPDn/8QAJBABAQADAAICAgIDAQAAAAAAAREAITFBURBhcZGBwaGx8PH/2gAIAQEAAT8htSoliiudKUXWGhdKoEnh7MR5X1kwY7M8t8GZTEoPHNOBvaqNzpb+JPbdES8+FtaVyHs0ONCu7WvQv1iimMWgsNQBOBWb5OlWcKNHGouLC51ySBUMYqTeYvP22U5FE89W3esnai5BRLxm4MEFdiuya1uO39f1jh/Oj2xQ9FmQ+jezAIGvhBmI3/DImVsFT6t9q0qgDG+w4LLGa38HY3Yg4vQVooN41Z3p5bwegt8uEFlBugoQKvVDBjbEHoYkbDZ0u/ghWvYHWKAoqHME+Forgb2eBErhH3KYxE7BTUgrRvKnqidJI/ulOORgzrQh5wJdyN4ijRJHimI1uTbAZTjSEOv0wLh/+tY3PAoK6vahaYMIFTAvKlvkuWcuE55ff5NaiybxCVVB2va1WKfx8VjCEqCAhS72zWPJDt/60Vy8XMOqOJmVZrZCwzytdgcHFAaR+TtumBUQO6E4Nb2meneNUPZ9aM/GTAsVrJL9ylGJXF3iLbU3VXgapayBNWIpxpgNSQ6Q54uP1/3+Mbkd/AeDVBoJ17gW3KUnB5ThK4E8fKVMTmr51DbfgIOhPsxadAVxr7TSJ1VEk76vQ5CSlO2qo041ObuHZDUVWtHRS597uLP3/vI2sI3jYiijrKITPj57j7sKE4XOgy6dgR5MKNYjsWcAIp56JI/BvgVEgV0FlTcxXrR4hdNEGbGQ0XLiZB8xd7GrZaiP5KKaYKFWOOPRlhhjpBUyuFpN06NoenIYmyBEKK7E/j732EjgA6NgUekXtb/p+ERUlnQG9vCClvENX7hKdG6zxOXMOtqtdYBZtXjAF0fzpGdn0+BQGRofIIHUA9OY0BaWarxyzQBcQxh6ErUGQAOmn5Fn3uASv7Th/jCzUwm8Y3h+8htkYOthAhv+h8XUSA4aR3GR2fZmkrZ6BMrQbeXyRYAU2ihs5ipMsWXc2Txu45PyBfN1hB1a2sjKK+pES7iHS+VpjcaLeHzrnrQ9qAHVfXLDb9Z71etdBR314UPPwOhKgowX8HdyyqdeBgN4RHZKcSVMfn4oS5HVWzCTQoX+MpR4IZBsonkumYgYuh67AGmzH2cZE/QZFKP3oLbRn69jhycISJT6PwXQCVZsmxFsrhT/AHtvtKI36rom4O6V/Lb3FHFqrY+OoE6FlU+OP/P7TLA2Y12DZG77zZ7w3ofymyim7F+CnWPn4Hl0Ma+YHlxQUkbiZ2wh0jgTMmFUBAprcrtfhBVhqaBOV8FcE3VIoexUyPHOnjFfo9E1fRn84onQQKLHBf3/ANPu4ybQMeKIsgbDSwShrHnWB4LVnLU5kIMFkwOVh94SN7b05uUV/GJKj4n+88Wgz0NTb/SN4vviUoIQ7sMrJjqxwT67u2xMz7D9X+GzEBEEDspq9O/pP1kX6WbOnxgDaDTBy0FMsMO9QX7Y6bu9b1f1NNb+AzkH47HAKQO5x4BYB39rEC6t8Zs5pt6JogwqaBwbtgxA8ke08fA0CX9H85wLhulFUBt3jrgJ7IVVChr4+BE/tJr2hx5atS6EZcQI8wj+CggGT1IMD7c9g1LXYdkEcnxOOzlXms0Nn6VSaRrKUIWpq23WWgEIkSEUn5YbqIN59QQEj8UNvHFy32ZqM+hzQW5LqLji7ikWzMI6ig7wEnnJQxhRjgTfwF08V1nE2Ho895r1IIxvAhOH8EC3lvUukkct30TSIuai4csA9ZshCRgIFE8rS/cEN5//xAAlEAEBAAMAAQQCAgMBAAAAAAABEQAhMUEQUWHwgZFx4aGxwdH/2gAIAQEAAT8QktFjgNnQoKsMGAW5RXDM6IC5dNKngj4NJRj3QTKdlYA6AK6BQpF3MdW4QNFsF6YAwxI0Ae1bYIsrIguhcUtGIi/OuwbgbGLWuSKEts4ng2VSgyErLtr+Kvg93K/RFrHc4HxBjX5D07yCpQRGgqDDawCYfBuNNJkGABEC6QJJVB4m9KQBd7eGQFURaKh+8qMs+0AaFMIG0x0gES4eBlC5QxCFWGAzsU2BXBhYVs5fFjTHBCSFaAiMR0vHBRAXBjLJD8dw6SdTA5jprp5BPhQBYZFFOCtumFYKr+UlTZ2yzeFhilSrxcvwOXLDksT2eRvpM7OiYuffj4/GIO+8nnftpXWBHBqjIKGq6Yomff44gW2/Y7bUEhP8RXOUskFIaZxf56wQHTUk7HeErvyJXjQyhUD2wh/eDZffOJI7JGDZOkVYU3fwZ41z/WBceXVOF8B/yJkS9IslW1DE+EgMuS3VrsdjLMyeaCIaImaKyA24JS2YZvw6AXkNoDFCNJ6UmcCrS5dDAM1ViNusSZsG79146vJC5aAIafFvQiIIKUqcL7LB/l1fr+lJPSQPSKt5kFSgegNa2KT+d70UCpVrSfcSxRav7yMS5tL8ZA0Ar06PfgZtSnSZYCRFTS13CI2x2B4UXfvyPqg3GShCf5IEWtBrbfL4+df03flMwjSYSrJaCTFPIP5mqFacxbvXtt2ao88MWbkmCEDEfv39YNsFaUkIdD55gzcPQSQjQBLPhi5zE+GpkRFORiX0yx15y+dSAANQBtrr3Xa4GZQv6oIZrpBZCvyhH6CSVDzkBvUrJeZjGWnJFYGQCDWQ0Fu/QASur2K6nItJj0d4g84UqUhm4CZ8/EA0y22VBhSAgpXBFCRaDZ/5kDZFiAXSJItGzHggACd6VOAAvCyzu2BWJ9WfqyCCkJFHsldi7GHr13jD25vD64hFpO3Fw0Vo5r1Nj0g2mEbAm5caaB+G0HUV+tna/naMi2LxhwwQpdoka3EBApUSVPAmAFqpXCenj3xQrlgps9xehBwgiVKo6dBO1IRCJgykXZVQ0F0T0gXxtcGjSVq8NGpugSHWH09vjHUBZcigo2EDyCtsvhnsLxnYTGPMGR2KAqd46FiLFI3wo05AIKLSejw2fTfwaIqtORsGxVpLNViA4nBDZWGCGM483aKWhK6+CImfiNw+/SZf6E6UNTRGg06iwBUkJePcCLZu+62+OKjMqvg9wklGwykuiWY5UXZdiHNoOzzlgkYbJBEKqBpWjFsEEMNFK0wjOehgsBYVCvYbFUOFzdb5WyfPYiyBDkRWKIj1sYkCzfITC/iuNpHpI7BaccbDOv8A1w4VMEEbqhRH8MkOQVYFiM7RRfb2Z9ttOBinkZ9DFIE8q0SCjHgD2zXV2QfNU7wUICRee0B1qk8yd0i+8hv9Q4K0ixEdLghEsNiSf3+/1jC0SYWw6OArz5xNsCK5mEC9xIh5Adq3t1oTX3BcJN+lYbaYQFmSKnFm0fkCfCCYOkpeAGiMFspkVSLvJuvlqN5fILF62okV6N3yBChRsQZqdhMAha9LmMs2olbSIB5EGx0DNWG3WDogTbIU62ZYfwIovfc96RApWKbWJ9+h74wp6AVowPZf13fEpYhayrc4kTUR3JnxjjDQSJ5eec/nF2P2FALvwj/x7etq2MGKTTTpxOlA3F1JtI0CxRHQg+s02wSOvfFZaoyMLk8PFlwJ/wAgExAKoNQV6CX4vMED4Ub3ssU1Ocjt84NIjQEiffj4/GIZ0rf6PYTWwETTpjKMWflDwZuaVbnXjpie+qjbFgfS8hyr5BUTQeBv39+Xz99394UIIU2ABUVIHoZdsgHiKMRotqphJGgingKpEBE0yJhkCEfFTJyMOaMBgAmYbYlW4AHjP//EABQRAQAAAAAAAAAAAAAAAAAAAHD/2gAIAQIBAT8AKv/EABQRAQAAAAAAAAAAAAAAAAAAAHD/2gAIAQMBAT8AKv/Z"

/***/ }),

/***/ 898:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ucm_venturelab.b3cf161c.jpg";

/***/ }),

/***/ 899:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/wet_center.86923035.png";

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(13);
	
	var _AboutUsSplash = __webpack_require__(359);
	
	var _AboutUsSplash2 = _interopRequireDefault(_AboutUsSplash);
	
	var _HeadshotImg = __webpack_require__(368);
	
	var _HeadshotImg2 = _interopRequireDefault(_HeadshotImg);
	
	var _NBCLC_Logo = __webpack_require__(102);
	
	var _NBCLC_Logo2 = _interopRequireDefault(_NBCLC_Logo);
	
	var _kellCircleLow = __webpack_require__(883);
	
	var _kellCircleLow2 = _interopRequireDefault(_kellCircleLow);
	
	var _kevinCircleLow = __webpack_require__(884);
	
	var _kevinCircleLow2 = _interopRequireDefault(_kevinCircleLow);
	
	var _desCircleLow = __webpack_require__(876);
	
	var _desCircleLow2 = _interopRequireDefault(_desCircleLow);
	
	var _bali = __webpack_require__(871);
	
	var _bali2 = _interopRequireDefault(_bali);
	
	var _ebclc = __webpack_require__(878);
	
	var _ebclc2 = _interopRequireDefault(_ebclc);
	
	var _lccr = __webpack_require__(886);
	
	var _lccr2 = _interopRequireDefault(_lccr);
	
	var _selc = __webpack_require__(892);
	
	var _selc2 = _interopRequireDefault(_selc);
	
	var _ucm_venturelab = __webpack_require__(898);
	
	var _ucm_venturelab2 = _interopRequireDefault(_ucm_venturelab);
	
	var _skydeck = __webpack_require__(893);
	
	var _skydeck2 = _interopRequireDefault(_skydeck);
	
	var _lylescenter = __webpack_require__(887);
	
	var _lylescenter2 = _interopRequireDefault(_lylescenter);
	
	var _wet_center = __webpack_require__(899);
	
	var _wet_center2 = _interopRequireDefault(_wet_center);
	
	var _impacthuboakland = __webpack_require__(882);
	
	var _impacthuboakland2 = _interopRequireDefault(_impacthuboakland);
	
	var _berkeleyhaas = __webpack_require__(872);
	
	var _berkeleyhaas2 = _interopRequireDefault(_berkeleyhaas);
	
	var _ocedfresno = __webpack_require__(889);
	
	var _ocedfresno2 = _interopRequireDefault(_ocedfresno);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutUsPage = function AboutUsPage() {
		return _react2.default.createElement(
			'div',
			{ className: 'content' },
			_react2.default.createElement(_AboutUsSplash2.default, null),
			_react2.default.createElement(
				_reactMd.Card,
				{ className: 'md-block-centered main-content-card' },
				_react2.default.createElement(
					_reactMd.CardText,
					null,
					_react2.default.createElement(
						_reactMd.Grid,
						null,
						_react2.default.createElement(
							_reactMd.Cell,
							{ size: 8, style: { margin: 'auto' } },
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement('img', {
									className: 'svg-icon'
									// style={{ width: '180px' }}
									, src: _NBCLC_Logo2.default,
									alt: 'New Business Community Law Clinic logo',
									style: {
										width: '200px',
										height: '100px',
										marginLeft: 'auto',
										marginRight: 'auto',
										marginBottom: '2rem',
										display: 'block'
									}
								})
							),
							_react2.default.createElement(
								'h2',
								{ style: { textAlign: 'center' } },
								'Our Clinic'
							),
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'a',
									{
										href: 'https://www.law.berkeley.edu/experiential/clinics/new-business-community-law-clinic/',
										target: '_blank',
										rel: 'noopener noreferrer'
									},
									'The New Business Community Law Clinic'
								),
								' ',
								'is an interdisciplinary transactional law clinic at Berkeley Law, in which JD and MBA students have assisted start-up entrepreneurs since 2007. The Clinic provides free legal help for start-ups and real experience for JD students looking to practice transactional law. Since its inception, the Clinic has provided individual legal assistance to over 200 start-ups, and trained and consulted with over 300.'
							),
							_react2.default.createElement(
								'h2',
								{ style: { textAlign: 'center' } },
								'Leadership'
							),
							_react2.default.createElement(_HeadshotImg2.default, {
								imgPath: _kellCircleLow2.default,
								name: 'William Kell',
								jobTitle: 'SUPERVISING ATTORNEY AND DIRECTOR'
							}),
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'a',
									{
										href: 'https://www.law.berkeley.edu/our-faculty/faculty-profiles/william-kell/',
										target: '_blank',
										rel: 'noopener noreferrer'
									},
									'William Kell'
								),
								' ',
								'has been practicing law since 1987, and teaching clinical programs since 1995. Before coming to Berkeley Law in 2001, he founded two clinics: a child advocacy clinic at Indiana University Law School, and a small business clinic at Cornell Law School. At Berkeley Law, he also started the New Business Community Law Clinic, an interdisciplinary clinical program designed to involve law and business students in assisting start-up businesses. Each term he serves as Supervising Attorney and Instructor for the Clinic course. Each term he also teaches another transactional law course: Drafting Legal Documents for New Businesses, in which students learn how to draft formative documents for businesses. In the past, he has also taught courses on Children and the Law and Mental Health Law. Mr. Kell also regularly presents on transactional law clinical education at national and regional conferences.'
							),
							_react2.default.createElement(_HeadshotImg2.default, { imgPath: _kevinCircleLow2.default, name: 'Kevin Xu', jobTitle: 'DEPUTY ATTORNEY' }),
							_react2.default.createElement(
								'p',
								null,
								'Kevin Xu has had the privilege of working within the Berkeley Law New Business Community Law Clinic since 2013, first as a law student, and then as a practicing attorney after graduating. Mr. Xu spearheads the Clinic\'s efforts to provide',
								' ',
								_react2.default.createElement(
									'a',
									{
										href: 'https://www.law.berkeley.edu/experiential/clinics/new-business-community-law-clinic/events/',
										target: '_blank',
										rel: 'noopener noreferrer'
									},
									'free legal office hours'
								),
								' ',
								'to new businesses in the East Bay and Central Valley. When he\'s not supervising law students or presenting legal workshops, Mr. Xu designs and builds internal automation tools for the Clinic using React and NodeJS, and data visualizations using D3.'
							),
							_react2.default.createElement(_HeadshotImg2.default, { imgPath: _desCircleLow2.default, name: 'Des LaFleur', jobTitle: 'DEPUTY ATTORNEY' }),
							_react2.default.createElement(
								'p',
								null,
								'Des Lafleur is our resident fashion law guru. She has been involved with the Clinic since 2010 as a student, then a fellow, and now as one of the Deputy Attorneys. In her current role, she leads entrepreneur outreach with immigrant and Spanish speaking communities. Her primary focus areas are IP, marketing, and brand protection\u2014topics she covers in classes and always advises clients to consider. She assists with some of the Clinic\'s English workshops and heads its foreign language workshops.'
							),
							_react2.default.createElement(
								'h2',
								{ style: { textAlign: 'center' } },
								'Our East Bay Starts Partners'
							),
							_react2.default.createElement(
								'div',
								{ className: 'partner-logos-container' },
								_react2.default.createElement(
									'a',
									{
										href: 'https://www.bayarealegalincubator.org/',
										target: '_blank',
										rel: 'noopener noreferrer'
									},
									_react2.default.createElement('img', { src: _bali2.default, style: { height: '80px', margin: '14px' }, alt: 'BALI Logo' })
								),
								_react2.default.createElement(
									'a',
									{ href: 'https://ebclc.org/', target: '_blank', rel: 'noopener noreferrer' },
									_react2.default.createElement('img', { src: _ebclc2.default, style: { height: '200px', margin: '14px' }, alt: 'EBCLC Logo' })
								),
								_react2.default.createElement(
									'a',
									{
										href: 'https://www.lccr.com/get-help/economic-justice-legal-services-for-entrepreneurs-lse/',
										target: '_blank',
										rel: 'noopener noreferrer'
									},
									_react2.default.createElement('img', { src: _lccr2.default, style: { height: '200px', margin: '14px' }, alt: 'LCCR Logo' })
								),
								_react2.default.createElement(
									'a',
									{ href: 'http://www.theselc.org/', target: '_blank', rel: 'noopener noreferrer' },
									_react2.default.createElement('img', { src: _selc2.default, style: { height: '80px', margin: '14px' }, alt: 'SELC Logo' })
								)
							),
							_react2.default.createElement(
								'h2',
								{ style: { textAlign: 'center' } },
								'Our Accelerator/Incubator Partners'
							),
							_react2.default.createElement(
								'div',
								{ className: 'partner-logos-container' },
								_react2.default.createElement(
									'a',
									{ href: 'https://venturelab.ucmerced.edu/', target: '_blank', rel: 'noopener noreferrer' },
									_react2.default.createElement('img', {
										src: _ucm_venturelab2.default,
										style: { height: '80px', margin: '14px' },
										alt: 'UCM Venture Lab Logo'
									})
								),
								_react2.default.createElement(
									'a',
									{
										href: 'http://www.fresnostate.edu/academics/lylescenter/',
										target: '_blank',
										rel: 'noopener noreferrer'
									},
									_react2.default.createElement('img', {
										src: _lylescenter2.default,
										style: { height: '150px', margin: '14px' },
										alt: 'Lyles Center for Innovation and Entrepreneurship Logo'
									})
								),
								_react2.default.createElement(
									'a',
									{ href: 'http://wetcenter.org/', target: '_blank', rel: 'noopener noreferrer' },
									_react2.default.createElement('img', {
										src: _wet_center2.default,
										style: { height: '120px', margin: '14px' },
										alt: 'Water, Energy, and Technology Center Logo'
									})
								),
								_react2.default.createElement(
									'a',
									{ href: 'http://skydeck.berkeley.edu/', target: '_blank', rel: 'noopener noreferrer' },
									_react2.default.createElement('img', {
										src: _skydeck2.default,
										style: { height: '30px', margin: '14px' },
										alt: 'SkyDeck Logo'
									})
								),
								_react2.default.createElement(
									'a',
									{
										href: 'http://entrepreneurship.berkeley.edu/',
										target: '_blank',
										rel: 'noopener noreferrer'
									},
									_react2.default.createElement('img', {
										src: _berkeleyhaas2.default,
										style: { height: '70px', margin: '14px' },
										alt: 'Entrepreneurship @ Berkeley Haas Logo'
									})
								),
								_react2.default.createElement(
									'a',
									{
										href: 'http://www.fresnostate.edu/academics/oced/',
										target: '_blank',
										rel: 'noopener noreferrer'
									},
									_react2.default.createElement('img', {
										src: _ocedfresno2.default,
										style: { height: '130px', margin: '14px' },
										alt: 'Office of Community and Economic Development at Fresno State Logo'
									})
								),
								_react2.default.createElement(
									'a',
									{ href: 'https://oakland.impacthub.net/', target: '_blank', rel: 'noopener noreferrer' },
									_react2.default.createElement('img', {
										src: _impacthuboakland2.default,
										style: { height: '100px', margin: '14px' },
										alt: 'Impact Hub Oakland Logo'
									})
								)
							)
						)
					)
				)
			)
		);
	};
	
	exports.default = AboutUsPage;
	module.exports = exports['default'];

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/NBCLC_Logo.1236c4d5.svg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-us-js-9b1fc21de24e2c68bd15.js